// extracted by mini-css-extract-plugin
module.exports = {"progress":"progress--3U-pB","wave":"wave--3UTNo","menu":"menu--3O5Z6"};
    if(module.hot) {
      // 1732531523393
      var cssReload = require("/home/kartik/kvr-lsf/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"esModule":false,"modules":{"namedExport":false},"locals":true});
      module.hot.dispose(cssReload);
      
    }
  